import _ from 'lodash';

const LibraryHelper = () => {
  const getUniqueCleanLicenseNames = (versions, licenseProp = 'licenseInfoModels') => {
    const res = _(versions)
      .flatMap(version => {
        return version[licenseProp];
      })
      .map(license => {
        return { name: license.name, license: license.license };
      })
      .filter(license => {
        //Only get those licenses with names
        return license.license !== null && license.license !== undefined && license.license !== '';
      })
      .uniqBy(license => {
        //Get unique name and license full name
        return license.name && license.license;
      })
      .map(license => {
        //Extract clean license name from parentheses
        //eg. This extracts Apache-2.0 from Apache License 2.0 (Apache-2.0)
        const regExp = /\(([^)]+)\)/;
        const matches = regExp.exec(license.license);
        //If clean license name exists within the parentheses return it, otherwise return the name.
        //If name is null just return the whole license name from license.license.
        let cleanName = (matches && matches[1]) || license.name || license.license;
        return cleanName;
      })
      .filter(name => {
        return name !== null && name !== undefined && name !== '';
      })
      .value();

    return res;
  };

  return {
    getUniqueCleanLicenseNames,
  };
};

export default new LibraryHelper();
